import { client } from "@/shared/api/pref-storage";
import { Portfolio } from "@/types/Portfolio";
import { noteListCreated } from "../recentlyCreated";

export const endpoints = {
  GetPortfolios: "/portfolios",
  PostPortfolios: "/portfolios",
};

export const getPortfolios = async () => {
  const response = await client.get(endpoints.GetPortfolios);
  return response.data as Portfolio[];
};

/**
 * Resolves to the created record, whose `id` is the one to use afterwards.
 *
 * Callers still send an `id` (Portfolio requires one), but PortfolioCreate has
 * no such field and the server allocates its own. Anything that keeps using
 * the id it sent is pointing at a different list, or at none.
 */
export const createPortfolio = async (
  portfolioData: Portfolio
): Promise<Portfolio> => {
  const response = await client.post(endpoints.PostPortfolios, portfolioData);
  const created = response.data as Portfolio;
  // See ../recentlyCreated.
  noteListCreated("watchlist", created?.id);
  return created;
};

export const updatePortfolio = async (portfolioData: Portfolio) => {
  const response = await client.patch(
    `${endpoints.GetPortfolios}/${portfolioData.id}`,
    portfolioData
  );
  return response.data;
};

export const deletePortfolio = async (portfolioId: string) => {
  const response = await client.delete(
    `${endpoints.GetPortfolios}/${portfolioId}`
  );
  return response.data;
};

export { usePortfoliosCRUD } from "./usePortfoliosCRUD";
